import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';
import View from './views/View.js';

const controlRecipes = async function () {
  try {
    const id = window.location.hash.slice(1);

    if (!id) return;
    recipeView.renderSpinner();

    // 0) Update results view to mark selected search result
    resultsView.render(model.getSearchResultsPage());

    // 1) Updating bookmarks view
    bookmarksView.render(model.state.bookmarks);

    // 2) Loading recipe
    await model.loadRecipe(id);

    // 3) Rendering recipe
    recipeView.render(model.state.recipe);

   
  } catch (err) {
    recipeView.renderError();
    console.error(err);
  }
};

const controlSearchResults = async function () {
  try {
    resultsView.renderSpinner();

    // 1) Get search query
    const query = searchView.getQuery();
    if (!query) return;

    // 2) Load search results
    await model.loadSearchResults(query);

    // 3) Render results
    resultsView.render(model.getSearchResultsPage());

    // 4) Render initial pagination buttons
    paginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controlPagination = function(goToPage) {
  
  resultsView.render(model.getSearchResultsPage(goToPage));
  paginationView.render(model.state.search)
}

const controlServings = function(newServings) {
  model.updateServings(newServings);

  recipeView.render(model.state.recipe);

}

const controlAddBookmark = function () {
  //add or remove bookmark
  if(!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  
  else {
    model.deleteBookmark(model.state.recipe.id);
  }
  
  recipeView.render(model.state.recipe); //re-render to update the markup for bookmarked icon

  bookmarksView.render(model.state.bookmarks);
}

const controlAddRecipe = async function(newRecipe) {
try {
  console.log(newRecipe);
  await model.uploadRecipe(newRecipe);
  console.log(model.state.recipe);
  recipeView.render(model.state.recipe);

  addRecipeView.renderMessage("Thanks For Adding Your Favourite Recipes");
  window.history.pushState(null,'',`#${model.state.recipe.id}`);
  setTimeout(function() {
    
    addRecipeView._toggleWindow();
    
  },MODAL_CLOSE_SEC*1000);

} catch(err)
{
  console.error(err);
  addRecipeView.renderError(err.message);
}
}
const init = function () {

  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);

  paginationView.addHandlerClick(controlPagination);
  addRecipeView._addHandlerShowWindow();
  addRecipeView._addHandlerUpload(controlAddRecipe);
 
 
};
init();

const clearBookmarks = function () {
  localStorage.clear('bookmarks');
}

// clearBookmarks();

const newFeature = function() {
  console.log("new-feature");
}